import { render } from "./LicensesComponent.vue?vue&type=template&id=01ed7cc2"
import script from "./LicensesComponent.vue?vue&type=script&lang=js"
export * from "./LicensesComponent.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__